export const routeName = 'privacy-policy';
export const slugs: Record<string, string> = {
	en: 'privacy-policy',
	es: 'politica-de-privacidad',
	ca: 'politica-de-privacitat',
	it: 'informativa-sulla-privacy',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-02-24' };
